import actionTypes from '@atom/actions/actionTypes';

export const updateWorkTemplatesView = data => ({
  type: actionTypes.UPDATE_WORK_TEMPLATES_VIEW,
  data,
});
